import { render, staticRenderFns } from "./attribute.vue?vue&type=template&id=b89e28cc&"
import script from "./attribute.vue?vue&type=script&lang=js&"
export * from "./attribute.vue?vue&type=script&lang=js&"
import style0 from "./attribute.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports